import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zhCN from './locales/zh-cn.json';
import zhHK from './locales/zh-hk.json';
import enUS from './locales/en-us.json';

export const defaultNS = 'translation';
export const resources = {
  'zh-CN': { translation: zhCN },
  'zh-HK': { translation: zhHK },
  'en-US': { translation: enUS },
} as const;

export const supportedLanguages = [
  { code: 'zh-CN', name: '简体中文' },
  { code: 'zh-HK', name: '繁體中文' },
  { code: 'en-US', name: 'English' },
] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en-US',
    defaultNS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
